const CHANNEL = {
	DIALOG: 'com.toyota.tme.t1.dialog',
	USER: 'com.toyota.tme.user',
	MY_TOYOTA: `com.toyota.tme.t1.mytoyota`,
	HASH: `com.toyota.tme.t1.hash`
};

export const event = {
	MATERIALBOX_CLOSE: {
		CHANNEL: CHANNEL.DIALOG,
		TOPIC: 'materialBox.close'
	},
	MATERIALBOX_OPENED: {
		CHANNEL: CHANNEL.DIALOG,
		TOPIC: 'materialBox.opened'
	},
	MATERIALBOX_CLOSED: {
		CHANNEL: CHANNEL.DIALOG,
		TOPIC: 'materialBox.closed'
	},
	USER_LOGIN_SUCCESS: {
		CHANNEL: CHANNEL.USER,
		TOPIC: 'sso.login.ok'
	},
	OPEN_SSO: {
		CHANNEL: CHANNEL.MY_TOYOTA,
		TOPIC: 'sso.render'
	},
	SET_HASH: {
		CHANNEL: CHANNEL.HASH,
		TOPIC: 'hash.change'
	}
};